const charterSpecialFeaturesRow = {
  key: 'charter-special-features-row',
  componentKey: 'row',
  label: 'Charter special features row'
};

export default charterSpecialFeaturesRow;
